(ns app.subscription.services
  "The prices, description and other details for different services we charge for
   in the context of the usage-based-pricing.")

#_(def tax
    ;; Not all customers pay such a high VAT like in Germany:
    0.19)

#_(defn net
    [gross]
    (/ (bigdec gross)
       (+ 1 tax)))

;; net + (net * 0.19) = gross
;;
;; 1 * net + 0.19 * net = gross
;;
;; 1.19 * net = gross

(defn get-services
  [_w]
  [{:id :storage-flat-fee
    :name "Storage flat-fee"
    :description "for all your images, videos, etc."
    :tooltip "Storrito pays a Cloud provider to securely store your images, audio and video files. Until we are able to offer exact storage billing, we charge this very low flat-fee each day."
    :price 0.10M
    :billing-unit :day
    :units-min 1
    :units-max 1
    :default-units 1
    }
   {:id :instagram-connection
    :name "Instagram account connection"
    :description "Unlimited Stories and Reels for one Instagram username."
    :tooltip "Post as many Stories and Reels as you like for one given Instagram username. Charged each day as long as the Instagram account is connected to Storrito."
    :price 0.50M
    :billing-unit :day
    :units-min 0
    :units-max 200
    :default-units 1}
   {:id :tiktok-post
    :name "TikTok post"
    :description "Publish a video or image on TikTok."
    :tooltip "Storrito allows to publish video and images to TikTok. Here we are able to only charge you based on how many images and videos you post."
    :price 0.08M
    :billing-unit :post
    :units-min 0
    :units-max 2000
    :default-units 0}
   {:id :youtube-short
    :name "YouTube Short"
    :description "Publish a rendered video as a YouTube Short."
    :tooltip "Storrito uploads square or vertical videos up to three minutes to YouTube Shorts. Here we charge per uploaded Short."
    :price 0.08M
    :billing-unit :post
    :units-min 0
    :units-max 2000
    :default-units 0}
   {:id :social-post
    :name "Social post"
    :description "Publish a rendered video or image on Facebook, Threads and other connected platforms (X is billed separately)."
    :tooltip "Storrito publishes your videos and images on your connected social accounts, such as Facebook pages and Threads profiles. Here we charge per published post."
    :price 0.08M
    :billing-unit :post
    :units-min 0
    :units-max 2000
    :default-units 0}
   ;; X charges every post made through its API, and a lot more for a
   ;; post whose text contains a link; `app.bundle-social.billing` bills
   ;; the latter as `:x-post-link`.
   {:id :x-post
    :name "X post"
    :description "Publish a rendered video on X. X charges for every post made through its API, so X posts cost more than other social posts."
    :tooltip "X charges for every post that is published through its API. Storrito passes this cost on, which is why an X post costs more than a post on other networks."
    :price 0.12M
    :billing-unit :post
    :units-min 0
    :units-max 2000
    :default-units 0}
   {:id :x-post-link
    :name "X post with a link"
    :description "An X post whose text contains a link. X charges a lot more for posts with links."
    :tooltip "X charges a lot more for a post whose text contains a link. Storrito passes this cost on. Leave links, including bare domains like example.com, out of the caption to pay the regular X post price."
    :price 0.40M
    :billing-unit :post
    :units-min 0
    :units-max 2000
    :default-units 0}
   {:id :ai-image
    :name "AI Image"
    :tooltip "The Storrito editor provides several integrations to generate images by using AI."
    :description "Generation of an image with AI (Dall-e / Blackforest)."
    :price 0.18M
    :billing-unit :image
    :units-min 0
    :units-max 2000
    :default-units 0}])

(defn get-service->prices
  [w]
  (into {}
        (map (juxt :id :price))
        (get-services w)))
